import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	createTransactionRegistryQuery,
	Transaction,
	TransactionRegistryFilters,
} from 'shared/api';
import {
	createDateFilterModel,
	createRegistryModel,
	DateFilterModel,
	getToday,
	RegistryCallbacks,
	RegistryModel,
} from 'shared/lib';

type CreateTransactionRegistryModelParams = {
	$accountId: Store<number | null>;
	currencies: Store<string[]>;
} & RegistryCallbacks;

export type TransactionRegistryModel = {
	model: RegistryModel<Transaction, TransactionRegistryFilters, JsonApiRequestError>;
	currencies: Store<string[]>;
	dateFilterModel: DateFilterModel;
};

export const createTransactionRegistryModel = ({
	$accountId,
	currencies,
	...params
}: CreateTransactionRegistryModelParams): TransactionRegistryModel => {
	const query = createTransactionRegistryQuery($accountId);

	const [todayDate, currentTimeZone] = getToday();

	const model = createRegistryModel({
		query,
		filters: {
			dateTo: todayDate,
			dateFrom: todayDate,
			timeZone: currentTimeZone,
			currencies: [],
		},
		...params,
	});

	const dateFilterModel = createDateFilterModel({
		fromChange: model.filters.dateFrom.setValue,
		toChange: model.filters.dateTo.setValue,
	});

	return { model, currencies, dateFilterModel };
};
